export const termsConditions = [
    {
        subtitle: "1. Aceptación de los Términos",
        text: "Al acceder o utilizar easyroom, aceptas estar sujeto a estos términos y condiciones. Si no estás de acuerdo con alguna parte de los términos, por favor no utilices nuestro software.",
    },
    {
        subtitle: "2. Licencia de Uso",
        text: "La utilización de easyroom está sujeta a una licencia de uso concedida por nosotros. Esta licencia está destinada exclusivamente para uso comercial en el ámbito hotelero. No está permitido el uso del software para fines no relacionados con la gestión de hoteles.",
    },
    {
        subtitle: "3. Responsabilidad del Usuario",
        text: "Eres responsable de garantizar que el uso de easyroom cumpla con todas las leyes y regulaciones aplicables en tu jurisdicción. No nos hacemos responsables de cualquier uso indebido o ilegal del software por parte del usuario.",
    },
    {
        subtitle: "4. Privacidad y Datos",
        text: "Respetamos la privacidad de tus datos y nos comprometemos a protegerlos. El uso de easyroom está sujeto a nuestra política de privacidad, que describe cómo recopilamos, utilizamos y protegemos tus datos.",
    },
    {
        subtitle: "5. Actualizaciones y Mantenimiento",
        text: "Nos reservamos el derecho de realizar actualizaciones y mantenimiento periódicos en nuestro software para garantizar su funcionamiento óptimo y la seguridad de los datos. Te notificaremos sobre cualquier actualización importante que pueda afectar el uso de easyroom.",
    },
    {
        subtitle: "6. Modificaciones de los Términos",
        text: "Nos reservamos el derecho de modificar o actualizar estos términos y condiciones en cualquier momento sin previo aviso. Se te notificará cualquier cambio importante en nuestros términos a través del software o por correo electrónico.",
    },
    {
        subtitle: "7. Ley Aplicable",
        text: "Estos términos y condiciones se rigen por las leyes de México sin tener en cuenta sus disposiciones sobre conflictos de leyes.",
    },
]

export const roles = [
    {
        value: "socio_o_dueno_de_hotel",
        label: "Socio o dueño de hotel",
    },
    {
        value: "administrador",
        label: "Administrador",
    },
    {
        value: "colaborador",
        label: "Colaborador",
    },
    {
        value: "otro",
        label: "Otro",
    },
]

export const countrys = [
    {
        value: "Afghanistan",
        label: "Afganistán",
    },
    {
        value: "Albania",
        label: "Albania",
    },
    {
        value: "Algeria",
        label: "Algeria",
    },
    {
        value: "American Samoa",
        label: "Samoa Americana",
    },
    {
        value: "Andorra",
        label: "Andorra",
    },
    {
        value: "Angola",
        label: "Angola",
    },
    {
        value: "Anguilla",
        label: "Anguilla",
    },
    {
        value: "Antarctica",
        label: "Antártida",
    },
    {
        value: "Antigua and Barbuda",
        label: "Antigua y Barbuda",
    },
    {
        value: "Argentina",
        label: "Argentina",
    },
    {
        value: "Armenia",
        label: "Armenia",
    },
    {
        value: "Aruba",
        label: "Aruba",
    },
    {
        value: "Australia",
        label: "Australia",
    },
    {
        value: "Austria",
        label: "Austria",
    },
    {
        value: "Azerbaijan",
        label: "Azerbaiyán",
    },
    {
        value: "Bahamas",
        label: "Bahamas",
    },
    {
        value: "Bahrain",
        label: "Bahrein",
    },
    {
        value: "Bangladesh",
        label: "Bangladesh",
    },
    {
        value: "Barbados",
        label: "Barbados",
    },
    {
        value: "Belarus",
        label: "Bielorrusia",
    },
    {
        value: "Belgium",
        label: "Bélgica",
    },
    {
        value: "Belize",
        label: "Belice",
    },
    {
        value: "Benin",
        label: "Benín",
    },
    {
        value: "Bermuda",
        label: "Bermuda",
    },
    {
        value: "Bhutan",
        label: "Bután",
    },
    {
        value: "Bolivia",
        label: "Bolivia",
    },
    {
        value: "Bosnia and Herzegovina",
        label: "Bosnia-Herzegovina",
    },
    {
        value: "Botswana",
        label: "Botswana",
    },
    {
        value: "Brazil",
        label: "Brasil",
    },
    {
        value: "Brunei Darussalam",
        label: "Brunei",
    },
    {
        value: "Bulgaria",
        label: "Bulgaria",
    },
    {
        value: "Burkina Faso",
        label: "Burkina Faso",
    },
    {
        value: "Burundi",
        label: "Burundi",
    },
    {
        value: "Cambodia",
        label: "Camboya",
    },
    {
        value: "Cameroon",
        label: "Camerún",
    },
    {
        value: "Canada",
        label: "Canadá",
    },
    {
        value: "Cape Verde",
        label: "Cabo Verde",
    },
    {
        value: "Cayman Islands",
        label: "Islas Caimán",
    },
    {
        value: "Central African Republic",
        label: "República Centroafricana",
    },
    {
        value: "Chad",
        label: "Chad",
    },
    {
        value: "Chile",
        label: "Chile",
    },
    {
        value: "China",
        label: "China",
    },
    {
        value: "Christmas Island",
        label: "Isla de Navidad",
    },
    {
        value: "Cocos (Keeling) Islands",
        label: "Islas Cocos",
    },
    {
        value: "Colombia",
        label: "Colombia",
    },
    {
        value: "Comoros",
        label: "Comores",
    },
    {
        value: "Congo",
        label: "República del Congo",
    },
    {
        value: "Congo, The Democratic Republic of the",
        label: "República Democrática del Congo",
    },
    {
        value: "Cook Islands",
        label: "Islas Cook",
    },
    {
        value: "Costa Rica",
        label: "Costa Rica",
    },
    {
        value: "Cote D'Ivoire",
        label: "Costa de Marfíl",
    },
    {
        value: "Croatia",
        label: "Croacia",
    },
    {
        value: "Cuba",
        label: "Cuba",
    },
    {
        value: "Cyprus",
        label: "Chipre",
    },
    {
        value: "Czech Republic",
        label: "República Checa",
    },
    {
        value: "Denmark",
        label: "Dinamarca",
    },
    {
        value: "Djibouti",
        label: "Djibouti",
    },
    {
        value: "Dominica",
        label: "Dominica",
    },
    {
        value: "Dominican Republic",
        label: "República Dominicana",
    },
    {
        value: "Ecuador",
        label: "Ecuador",
    },
    {
        value: "Egypt",
        label: "Egipto",
    },
    {
        value: "El Salvador",
        label: "El Salvador",
    },
    {
        value: "Equatorial Guinea",
        label: "Guinea Ecuatorial",
    },
    {
        value: "Eritrea",
        label: "Eritrea",
    },
    {
        value: "Estonia",
        label: "Estonia",
    },
    {
        value: "Ethiopia",
        label: "Etiopía",
    },
    {
        value: "Falkland Islands (Malvinas)",
        label: "Islas Malvinas",
    },
    {
        value: "Faroe Islands",
        label: "Islas Feroe",
    },
    {
        value: "Fiji",
        label: "Fiji",
    },
    {
        value: "Finland",
        label: "Finlandia",
    },
    {
        value: "France",
        label: "Francia",
    },
    {
        value: "French Guiana",
        label: "Guyana Francesa",
    },
    {
        value: "French Polynesia",
        label: "Polinesia Francesa",
    },
    {
        value: "French Southern Territories",
        label: "Tierras Australes y Antárticas Francesas",
    },
    {
        value: "Gabon",
        label: "Gabón",
    },
    {
        value: "Gambia",
        label: "Gambia",
    },
    {
        value: "Georgia",
        label: "Georgia",
    },
    {
        value: "Germany",
        label: "Alemania",
    },
    {
        value: "Ghana",
        label: "Ghana",
    },
    {
        value: "Gibraltar",
        label: "Gibraltar",
    },
    {
        value: "Greece",
        label: "Grecia",
    },
    {
        value: "Greenland",
        label: "Groenlandia",
    },
    {
        value: "Grenada",
        label: "Granada",
    },
    {
        value: "Guadeloupe",
        label: "Guadalupe",
    },
    {
        value: "Guam",
        label: "Guam",
    },
    {
        value: "Guatemala",
        label: "Guatemala",
    },
    {
        value: "Guinea",
        label: "Guinea",
    },
    {
        value: "Guinea-Bissau",
        label: "Guinea-Bissau",
    },
    {
        value: "Guyana",
        label: "Guyana",
    },
    {
        value: "Haiti",
        label: "Haití",
    },
    {
        value: "Holy See (Vatican City State)",
        label: "Vaticano",
    },
    {
        value: "Honduras",
        label: "Honduras",
    },
    {
        value: "Hong Kong",
        label: "Hong Kong",
    },
    {
        value: "Hungary",
        label: "Hungría",
    },
    {
        value: "Iceland",
        label: "Islandia",
    },
    {
        value: "India",
        label: "India",
    },
    {
        value: "Indonesia",
        label: "Indonesia",
    },
    {
        value: "Iran, Islamic Republic Of",
        label: "Irán",
    },
    {
        value: "Iraq",
        label: "Iraq",
    },
    {
        value: "Ireland",
        label: "Irlanda",
    },
    {
        value: "Israel",
        label: "Israel",
    },
    {
        value: "Italy",
        label: "Italia",
    },
    {
        value: "Jamaica",
        label: "Jamaica",
    },
    {
        value: "Japan",
        label: "Japón",
    },
    {
        value: "Jordan",
        label: "Jordania",
    },
    {
        value: "Kazakhstan",
        label: "Kazajstán",
    },
    {
        value: "Kenya",
        label: "Kenia",
    },
    {
        value: "Kiribati",
        label: "Kiribati",
    },
    {
        value: "Korea, Democratic People'S Republic of",
        label: "Corea del Norte",
    },
    {
        value: "Korea, Republic of",
        label: "Corea del Sur",
    },
    {
        value: "Kuwait",
        label: "Kuwait",
    },
    {
        value: "Kyrgyzstan",
        label: "Kirguistán",
    },
    {
        value: "Lao People's Democratic Republic",
        label: "Laos",
    },
    {
        value: "Latvia",
        label: "Letonia",
    },
    {
        value: "Lebanon",
        label: "Líbano",
    },
    {
        value: "Lesotho",
        label: "Lesotho",
    },
    {
        value: "Liberia",
        label: "Liberia",
    },
    {
        value: "Libyan Arab Jamahiriya",
        label: "Libia",
    },
    {
        value: "Liechtenstein",
        label: "Liechtenstein",
    },
    {
        value: "Lithuania",
        label: "Lituania",
    },
    {
        value: "Luxembourg",
        label: "Luxemburgo",
    },
    {
        value: "Macao",
        label: "Macao",
    },
    {
        value: "Macedonia, The Former Yugoslav Republic of",
        label: "Macedonia",
    },
    {
        value: "Madagascar",
        label: "Madagascar",
    },
    {
        value: "Malawi",
        label: "Malawi",
    },
    {
        value: "Malaysia",
        label: "Malasia",
    },
    {
        value: "Maldives",
        label: "Maldivas",
    },
    {
        value: "Mali",
        label: "Mali",
    },
    {
        value: "Malta",
        label: "Malta",
    },
    {
        value: "Marshall Islands",
        label: "Islas Marshall",
    },
    {
        value: "Martinique",
        label: "Martinica",
    },
    {
        value: "Mauritania",
        label: "Mauritania",
    },
    {
        value: "Mauritius",
        label: "Mauricio",
    },
    {
        value: "Mayotte",
        label: "Mayotte",
    },
    {
        value: "Mexico",
        label: "México",
    },
    {
        value: "Micronesia, Federated States of",
        label: "Estados Federados de Micronesia",
    },
    {
        value: "Moldova, Republic of",
        label: "Moldavia",
    },
    {
        value: "Monaco",
        label: "Mónaco",
    },
    {
        value: "Mongolia",
        label: "Mongolia",
    },
    {
        value: "Montserrat",
        label: "Montserrat",
    },
    {
        value: "Morocco",
        label: "Marruecos",
    },
    {
        value: "Mozambique",
        label: "Mozambique",
    },
    {
        value: "Myanmar",
        label: "Myanmar",
    },
    {
        value: "Namibia",
        label: "Namibia",
    },
    {
        value: "Nauru",
        label: "Nauru",
    },
    {
        value: "Nepal",
        label: "Nepal",
    },
    {
        value: "Netherlands",
        label: "Holanda",
    },
    {
        value: "Netherlands Antilles",
        label: "Antillas Holandesas",
    },
    {
        value: "New Caledonia",
        label: "Nueva Caledonia",
    },
    {
        value: "New Zealand",
        label: "Nueva Zelanda",
    },
    {
        value: "Nicaragua",
        label: "Nicaragua",
    },
    {
        value: "Niger",
        label: "Niger",
    },
    {
        value: "Nigeria",
        label: "Nigeria",
    },
    {
        value: "Niue",
        label: "Niue",
    },
    {
        value: "Norfolk Island",
        label: "Islas Norfolk",
    },
    {
        value: "Northern Mariana Islands",
        label: "Islas Marianas del Norte",
    },
    {
        value: "Norway",
        label: "Noruega",
    },
    {
        value: "Oman",
        label: "Omán",
    },
    {
        value: "Pakistan",
        label: "Pakistán",
    },
    {
        value: "Palau",
        label: "Palau",
    },
    {
        value: "Palestinian Territory, Occupied",
        label: "Palestina",
    },
    {
        value: "Panama",
        label: "Panamá",
    },
    {
        value: "Papua New Guinea",
        label: "Papua Nueva Guinea",
    },
    {
        value: "Paraguay",
        label: "Paraguay",
    },
    {
        value: "Peru",
        label: "Perú",
    },
    {
        value: "Philippines",
        label: "Filipinas",
    },
    {
        value: "Pitcairn",
        label: "Pitcairn",
    },
    {
        value: "Poland",
        label: "Polonia",
    },
    {
        value: "Portugal",
        label: "Portugal",
    },
    {
        value: "Puerto Rico",
        label: "Puerto Rico",
    },
    {
        value: "Qatar",
        label: "Qatar",
    },
    {
        value: "Reunion",
        label: "Reunión",
    },
    {
        value: "Romania",
        label: "Rumanía",
    },
    {
        value: "Russian Federation",
        label: "Rusia",
    },
    {
        value: "Rwanda",
        label: "Ruanda",
    },
    {
        value: "Saint Helena",
        label: "Santa Helena",
    },
    {
        value: "Saint Kitts and Nevis",
        label: "San Kitts y Nevis",
    },
    {
        value: "Saint Lucia",
        label: "Santa Lucía",
    },
    {
        value: "Saint Vincent and the Grenadines",
        label: "San Vicente y Granadinas",
    },
    {
        value: "Samoa",
        label: "Samoa",
    },
    {
        value: "San Marino",
        label: "San Marino",
    },
    {
        value: "Sao Tome and Principe",
        label: "Santo Tomé y Príncipe",
    },
    {
        value: "Saudi Arabia",
        label: "Arabia Saudita",
    },
    {
        value: "Senegal",
        label: "Senegal",
    },
    {
        value: "Serbia and Montenegro",
        label: "Serbia",
    },
    {
        value: "Seychelles",
        label: "Seychelles",
    },
    {
        value: "Sierra Leone",
        label: "Sierra Leona",
    },
    {
        value: "Singapore",
        label: "Singapur",
    },
    {
        value: "Slovakia",
        label: "Eslovaquía",
    },
    {
        value: "Slovenia",
        label: "Eslovenia",
    },
    {
        value: "Solomon Islands",
        label: "Islas Salomón",
    },
    {
        value: "Somalia",
        label: "Somalia",
    },
    {
        value: "South Africa",
        label: "Sudáfrica",
    },
    {
        value: "Spain",
        label: "España",
    },
    {
        value: "Sri Lanka",
        label: "Sri Lanka",
    },
    {
        value: "Sudan",
        label: "Sudán",
    },
    {
        value: "Suriname",
        label: "Surinam",
    },
    {
        value: "Swaziland",
        label: "Swazilandia",
    },
    {
        value: "Sweden",
        label: "Suecia",
    },
    {
        value: "Switzerland",
        label: "Suiza",
    },
    {
        value: "Syrian Arab Republic",
        label: "Siria",
    },
    {
        value: "Taiwan, Province of China",
        label: "Taiwán",
    },
    {
        value: "Tajikistan",
        label: "Tadjikistan",
    },
    {
        value: "Tanzania, United Republic of",
        label: "Tanzania",
    },
    {
        value: "Thailand",
        label: "Tailandia",
    },
    {
        value: "Timor-Leste",
        label: "Timor Oriental",
    },
    {
        value: "Togo",
        label: "Togo",
    },
    {
        value: "Tokelau",
        label: "Tokelau",
    },
    {
        value: "Tonga",
        label: "Tonga",
    },
    {
        value: "Trinidad and Tobago",
        label: "Trinidad y Tobago",
    },
    {
        value: "Tunisia",
        label: "Túnez",
    },
    {
        value: "Turkey",
        label: "Turquía",
    },
    {
        value: "Turkmenistan",
        label: "Turkmenistan",
    },
    {
        value: "Turks and Caicos Islands",
        label: "Islas Turcas y Caicos",
    },
    {
        value: "Tuvalu",
        label: "Tuvalu",
    },
    {
        value: "Uganda",
        label: "Uganda",
    },
    {
        value: "Ukraine",
        label: "Ucrania",
    },
    {
        value: "United Arab Emirates",
        label: "Emiratos Árabes Unidos",
    },
    {
        value: "United Kingdom",
        label: "Reino Unido",
    },
    {
        value: "United States",
        label: "Estados Unidos",
    },
    {
        value: "Uruguay",
        label: "Uruguay",
    },
    {
        value: "Uzbekistan",
        label: "Uzbekistán",
    },
    {
        value: "Vanuatu",
        label: "Vanuatu",
    },
    {
        value: "Venezuela",
        label: "Venezuela",
    },
    {
        value: "Viet Nam",
        label: "Vietnam",
    },
    {
        value: "Virgin Islands, British",
        label: "Islas Vírgenes Británicas",
    },
    {
        value: "Virgin Islands, U.S.",
        label: "Islas Vírgenes Americanas",
    },
    {
        value: "Wallis and Futuna",
        label: "Wallis y Futuna",
    },
    {
        value: "Western Sahara",
        label: "Sáhara Occidental",
    },
    {
        value: "Yemen",
        label: "Yemen",
    },
    {
        value: "Zambia",
        label: "Zambia",
    },
    {
        value: "Zimbabwe",
        label: "Zimbabwe",
    },
]
